import React from 'react';

import styled from 'styled-components';
import { Container } from 'styles/admin';

import { Typography16, Typography17 } from 'uiToolkit/Typography';

import { useCustomRoleContext } from '../CustomRoleContext';
import CreateCustomRoleForm from './CreateCustomRoleForm';

const CreateCustomRole = () => {
  const {
    state: { editingRoleId },
  } = useCustomRoleContext();

  return (
    <Wrapper>
      <Typography16 bottomGutter={1.5}>{`${editingRoleId ? 'Edit' : 'Create'} Custom Access`}</Typography16>
      <Typography17 bottomGutter={3}>
        {`${editingRoleId ? 'Edit' : 'Create'} custom permissions for individuals
        across particular Function and Location`}
      </Typography17>
      <CreateCustomRoleForm />
    </Wrapper>
  );
};

const Wrapper = styled(Container)`
  height: 100%;
`;

export default CreateCustomRole;
